import { LotDetailScreen } from '../features/console';

export function LotDetailPage() {
  return <LotDetailScreen />;
}
